<app-dialog-header
  [heading]="actionType == 'add' ? 'Add Payer' : 'Edit Payer'"
  [subheading]="subheading()"
  [closeResult]="hasPersistedChanges"></app-dialog-header>

<mat-dialog-content class="payer-dialog__content">
  <app-card-section heading="Payer Details">
    <div class="payer-dialog__details">
      <mat-form-field color="primary" appearance="outline" floatLabel="always">
        <mat-label>Payer Full Name</mat-label>
        <input matInput placeholder="Enter Payer Full Name" [formControl]="nameControl" [required]="true" [maxlength]="nameMaxLength">
        @if (nameControl.hasError('required')) {
          <mat-error>Name is <strong>required</strong></mat-error>
        } @else if (nameControl.hasError('maxlength')) {
          <mat-error>Name can't be longer than {{nameMaxLength}} characters</mat-error>
        }
      </mat-form-field>

      <mat-form-field color="primary" appearance="outline" floatLabel="always">
        <mat-label>Abbreviation</mat-label>
        <input matInput placeholder="Enter Abbreviation" [formControl]="abbreviationControl" [required]="true" [maxlength]="abbreviationMaxLength">
        @if (abbreviationControl.hasError('required')) {
          <mat-error>Abbreviation is <strong>required</strong></mat-error>
        } @else if (abbreviationControl.hasError('maxlength')) {
          <mat-error>Abbreviation can't be longer than {{abbreviationMaxLength}} characters</mat-error>
        }
      </mat-form-field>

      <app-payer-alias-filter-select
        class="payer-dialog__aliases"
        [form]="payerForm"
        [label]="'Payer Aliases'"
        [showDisabledOptions]="true"
        [currentPayerID]="payerEditStore.currentPayerItem().PayerID"
        [queryOptions]="true"
        [placeholder]="'Make a Selection'"
        [required]="true"
        (ready)="isPayerAliasReady = true; filterReadyCheck();"></app-payer-alias-filter-select>
    </div>
  </app-card-section>

  <app-card-section heading="Risk Adjustment Policy" [badge]="serviceYearBadge()">
    <span
      sectionActions
      [matTooltip]="addServiceYearEntryEnabled() ? '' : 'Save the payer before adding service years.'"
      [matTooltipClass]="'app-tooltip'">
      <button
        mat-flat-button
        class="primary-button-longtext"
        [disabled]="!addServiceYearEntryEnabled()"
        (click)="onAddPolicyClick()">
        <mat-icon>add</mat-icon>
        Add Service Year
      </button>
    </span>

    <ag-grid-angular
      class="ag-theme-balham payer-dialog__grid"
      [domLayout]="'autoHeight'"
      [rowHeight]="52"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowData]="payerEditStore.riskAdjustmentPolicies()"
      [tooltipShowDelay]="0"
      [suppressCellFocus]="true"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
      [loadingOverlayComponent]="loadingOverlayComponent"
      [rowClassRules]="rowClassRules"
      [context]="gridContext"
      [getRowId]="getRowId"
      (rowDoubleClicked)="onEditPayerClick($event.data)"
      (gridReady)="onGridReady($event)"></ag-grid-angular>
  </app-card-section>
</mat-dialog-content>

<app-dialog-footer>
  @if (invalidServiceYear) {
    <span class="payer-dialog__error">Service Year range conflicts with existing entries.</span>
  }
  @if (emptyPolicyFields) {
    <span class="payer-dialog__error">Required fields are empty.</span>
  }
  <button mat-flat-button class="secondary-button" [mat-dialog-close]="hasPersistedChanges">Cancel</button>
  <button
    mat-flat-button
    class="primary-button"
    [disabled]="!canSave"
    (click)="onSaveClick()">
    Save
  </button>
</app-dialog-footer>
